import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '../../../core/modal/modal.service';

@Component({
  selector: 'tax-deregister',
  templateUrl: './deregister.component.html',
  styleUrls: ['./deregister.component.sass'],
})

export class DeregisterComponent {
  // @ts-ignore
  @Input() kkmId: number;

  constructor(
    private modalService: ModalService,
    private router: Router,
  ) {
  }

  continue(): void {
    this.modalService.close();
    this.router.navigate([`/main/kkms/deregister-kkm/${this.kkmId}`]);
  }
}
